import TextField from '@blueshift-ui/inputs/dist/components/text-field';
import ButtonUnstyled from '@mui/core/ButtonUnstyled';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@nrdy-marketing-engine/button';
import { useMemo, useState } from 'react';
import type { CartState, PromoCode } from '../../../@types/cart-state';
import { trackCartEvent, trackCartFailure } from '../../lib/track-service/track-cart';
import Field from '../shared/field';

function PromoCode({
  onApply,
  onRemove,
  cartState,
}: {
  cartState: CartState;
  onApply: (promoCode: string) => Promise<string>;
  onRemove: () => void;
}) {
  const [promoCode, setPromoCode] = useState<string>('');
  const [error, setError] = useState<string | undefined>();

  const appliedPromoCode = useMemo<PromoCode | undefined>(
    () => cartState.cart?.promo_codes && cartState.cart.promo_codes[0],
    [cartState]
  );

  const handleApply = () => {
    onApply(promoCode)
      .then(async (res) => {
        await trackCartEvent(
          'checkout_promo_code_applied',
          {
            clientUuid: cartState?.client?.uuid,
          },
          promoCode
        );
      })
      .catch(async (err) => {
        await trackCartFailure(
          'checkout_promo_code_not_applied',
          {
            clientUuid: cartState?.client?.uuid,
            error: err,
          },
          promoCode
        );
        setError('Promo code could not be applied');
      });
  };

  return (
    <>
      <Field>
        <Box>
          {appliedPromoCode ? (
            <>
              <Typography fontWeight="bold">{appliedPromoCode.code}</Typography>
              <Typography> - {appliedPromoCode.name}</Typography>
              <ButtonUnstyled onClick={() => onRemove()}>X</ButtonUnstyled>
            </>
          ) : (
            <>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Promo Code"
                onChange={(e) => setPromoCode(e.target.value)}
                value={promoCode}
              />
              {error && <div>{error}</div>}
            </>
          )}
        </Box>
      </Field>
      {!appliedPromoCode && (
        <Field>
          <Button onClick={handleApply}>Apply promo code</Button>
        </Field>
      )}
    </>
  );
}

export default PromoCode;
